import { render, staticRenderFns } from "./ActivityMessages.vue?vue&type=template&id=f51bf8aa&scoped=true&"
import script from "./ActivityMessages.vue?vue&type=script&lang=ts&"
export * from "./ActivityMessages.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityMessages.vue?vue&type=style&index=0&id=f51bf8aa&scoped=true&lang=scss&"
import style1 from "./ActivityMessages.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51bf8aa",
  null
  
)

export default component.exports